<template>
  <v-card :class="inline ? '' : 'mx-auto'" :width="inline ? undefined : '600px'" :flat="inline">
    <template v-if="!inline">
      <div class="pa-3 d-flex align-center">
        <h2>{{ $t('Fechamento de tarefa') }}</h2>
        <v-spacer />
        <v-alert
          type="error"
          v-show="error"
          transition="scale-transition"
          icon="mdi-alert-octagon-outline"
        >
          {{ errorMessage }}
        </v-alert>
        <v-spacer />
        <v-spacer />
        <v-btn dark color="#B14949" icon @click="close" v-if="step === 0">
          <v-icon color="#B14949">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <div v-if="inline" class="d-flex justify-center my-3">
      <h2>{{ $t('Fechamento de tarefa') }}</h2>
    </div>
    <v-divider v-if="inline" class="ma-6 my-2"></v-divider>

    <p class="text-center" v-if="step === 0 && !inline">
      {{
        $t(
          'Ao confirmar a TAREFA será bloqueada, impossibilitando futuras alterações'
        )
      }}
    </p>

    <v-divider v-if="!inline"></v-divider>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-row class="px-4 py-2 ma-0">
            <v-col class="pb-0" cols="12">
              <label class="label">{{ $t('Data e hora fechamento') }}</label>
              <div class="d-flex">
                <v-icon class="mr-1">mdi-calendar</v-icon>
                <date-picker
                  ref="datepicker"
                  style="width: 100%"
                  v-model="closeLaborDateTime"
                  mode="dateTime"
                  is24hr
                  :popover="{ visibility: 'click', positionFixed: 'true' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      :class="
                        closeLaborDateTimeError
                          ? 'date-input-error'
                          : 'date-input'
                      "
                      :value="inputValue"
                      v-on="inputEvents"
                      v-mask="['##/##/#### ##:##']"
                      @focus="setCloseNowDate"
                    />
                    <span
                      class="date-span-error"
                      v-if="closeLaborDateTimeError"
                      >{{ $t('Data de fechamento requerida') }}</span
                    >
                  </template>
                </date-picker>
              </div>
            </v-col>

            <v-col cols="12">
              <label class="label">{{ $t('Horas despendidas') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentLabor.hoursSpent"
                :rules="hoursSpentRules"
                v-mask="['##:##']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon large color="success"> mdi-checkbox-marked-circle </v-icon>
          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{ $t('Tarefa fechada com sucesso') }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn @click="close" v-if="step === 0" class="ml-4" color="#B14949" dark>
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="#426483" depressed @click="next" :loading="loading" dark>
        {{ $t(buttonText) }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.v-window {
  overflow: auto !important;
}

.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'

export default {
  props: {
    labor: Object,
    inline: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    if (this.labor) {
      this.currentLabor = { ...this.labor }
      this.closeLaborDateTime = this.labor.closeDate || null
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    loading: false,
    firstValid: false,
    error: false,
    closeLaborDateTimeError: false,
    closeLaborDateTime: null,
    currentLabor: {
      id: 0,
      closeDate: null,
      hoursSpent: '',
    },
    hoursSpentRules: [
      (v) => !!v || 'Horas despendidas requerida',
      (v) => (v && v.length == 5) || 'Tempo inválido',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      return this.step === 0 ? 'Confirmar' : 'Terminar'
    },
  },

  methods: {
    close() {
      if (this.step === 1) {
        this.$emit('taskClosed')
      }
      this.$emit('close')
    },

    setCloseNowDate() {
      this.closeLaborDateTime = !this.closeLaborDateTime
        ? new Date()
        : this.closeLaborDateTime
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.closeLaborDateTime) {
          await this.submit()
        } else {
          this.closeLaborDateTimeError = !this.closeLaborDateTime
        }
      } else {
        this.close()
      }
    },

    async submit() {
      this.loading = true

      const labor = {
        Id: this.currentLabor.id,
        CloseDate: Utils.nowDatetimeFormat(this.closeLaborDateTime),
        HoursSpent: this.currentLabor.hoursSpent,
      }

      await this.apiService
        .post('labor/closeLabor', labor)
        .then(() => {
          this.step = 1
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
    },
  },

  watch: {
    closeLaborDateTime: {
      deep: true,
      handler() {
        this.closeLaborDateTimeError = false
      },
    },
  },
}
</script>
